export default __webpack_public_path__ + "static/media/micitt.d091cd2a.png";